import 'vanilla-cookieconsent/dist/cookieconsent.css'
import './cookieConsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

export const COOKIE_CONSENT_CHANGED_EVENT = 'cookieConsentChanged'

let initialized = false

function emitChange() {
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_CHANGED_EVENT))
}

export function initCookieConsent() {
  if (initialized) return
  initialized = true

  ;(window as any).__cookieConsent = CookieConsent

  CookieConsent.run({
    onFirstConsent: emitChange,
    onConsent: emitChange,
    onChange: emitChange,
    guiOptions: {
      consentModal: { layout: 'box', position: 'bottom right', equalWeightButtons: true, flipButtons: false },
      preferencesModal: { layout: 'box', position: 'right', equalWeightButtons: true, flipButtons: false },
    },
    categories: {
      necessary: { readOnly: true, enabled: true },
      functional: {},
      analytics: {},
    },
    language: {
      default: 'pl',
      translations: {
        pl: {
          consentModal: {
            title: 'Używamy plików cookie',
            description:
              'Korzystamy z plików cookie aby zapewnić poprawne działanie aplikacji oraz analizować ruch. ' +
              'Szczegóły znajdziesz w <a href="/privacy" target="_blank">Polityce Prywatności</a>.',
            acceptAllBtn: 'Akceptuj wszystkie',
            acceptNecessaryBtn: 'Tylko niezbędne',
            showPreferencesBtn: 'Ustawienia',
          },
          preferencesModal: {
            title: 'Ustawienia plików cookie',
            acceptAllBtn: 'Akceptuj wszystkie',
            acceptNecessaryBtn: 'Tylko niezbędne',
            savePreferencesBtn: 'Zapisz wybór',
            closeIconLabel: 'Zamknij',
            sections: [
              {
                title: 'Pliki cookie niezbędne',
                description: 'Wymagane do działania aplikacji (np. sesja, autoryzacja). Nie można ich wyłączyć.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Funkcjonalne',
                description:
                  'Pozwalają zapamiętać Twoje preferencje (np. wybrany język, układ widoku, ostatnio używane filtry) ' +
                  'i oferować spersonalizowane funkcje aplikacji.',
                linkedCategory: 'functional',
              },
              {
                title: 'Pomoc techniczna i diagnostyka błędów (OpenReplay)',
                description:
                  'Używamy narzędzia <strong>OpenReplay</strong> do nagrywania sesji w aplikacji. ' +
                  'Nagrania pomagają nam diagnozować zgłaszane problemy i naprawiać błędy. ' +
                  'Pola haseł i pola wrażliwe są automatycznie pomijane, a nagrania są dostępne tylko dla zespołu EasyTacho. ' +
                  'Szczegóły: <a href="/privacy" target="_blank">Polityka Prywatności</a>.',
                linkedCategory: 'analytics',
              },
              {
                title: 'Więcej informacji',
                description:
                  'Szczegółowe zasady przetwarzania danych opisuje <a href="/privacy" target="_blank">Polityka Prywatności</a> ' +
                  'oraz <a href="/terms" target="_blank">Regulamin</a>.',
              },
            ],
          },
        },
      },
    },
  })
}

export function showCookiePreferences() {
  CookieConsent.showPreferences()
}

export function showCookieConsent() {
  CookieConsent.show(true)
}

export function hasGivenConsent(): boolean {
  return CookieConsent.validConsent()
}

export function hasAcceptedAllCookies(): boolean {
  return (
    CookieConsent.acceptedCategory('functional') &&
    CookieConsent.acceptedCategory('analytics')
  )
}
